// URL ⇄ state helpers for the Forecast page. URL is the source of truth.
// All coordinates are rounded to ROUND_DP decimal places — this matches the
// precision stored for saved spots so coord-equality comparisons line up.
// Times are UTC HHMM, snapped to a 30-minute grid (Skysight's model timestep).

export const ROUND_DP = 5;
const VALID_FEATURES = new Set(['point', 'skewt']);

const roundDp = (n) => {
    const f = Math.pow(10, ROUND_DP);
    return Math.round(n * f) / f;
};

const parseFiniteNumber = (raw) => {
    if (raw === null || raw === undefined || raw === '') return null;
    const n = Number(raw);
    return Number.isFinite(n) ? roundDp(n) : null;
};

const parseDate = (raw) => {
    if (typeof raw !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(raw)) return null;
    const d = new Date(`${raw}T00:00:00Z`);
    return Number.isFinite(d.getTime()) && d.toISOString().slice(0, 10) === raw ? raw : null;
};

const parseTime = (raw) => {
    if (typeof raw !== 'string' || !/^\d{4}$/.test(raw)) return null;
    const hh = Number(raw.slice(0, 2));
    const mm = Number(raw.slice(2));
    if (hh < 0 || hh > 23) return null;
    if (mm < 0 || mm > 59) return null;
    // Snap minutes down to the 30-min grid (00 or 30)
    const mmSnapped = mm >= 30 ? 30 : 0;
    return String(hh).padStart(2, '0') + String(mmSnapped).padStart(2, '0');
};

export const parseUrlState = (searchParams) => ({
    lat: parseFiniteNumber(searchParams.get('lat')),
    lng: parseFiniteNumber(searchParams.get('lng')),
    date: parseDate(searchParams.get('date')),
    time: parseTime(searchParams.get('time')),
    site: searchParams.get('site') || null,
    feature: VALID_FEATURES.has(searchParams.get('feature')) ? searchParams.get('feature') : null,
});

export const buildSearchParams = (state) => {
    const sp = new URLSearchParams();
    if (state.lat !== null && state.lat !== undefined && Number.isFinite(state.lat)) {
        sp.set('lat', String(roundDp(state.lat)));
    }
    if (state.lng !== null && state.lng !== undefined && Number.isFinite(state.lng)) {
        sp.set('lng', String(roundDp(state.lng)));
    }
    if (state.date) sp.set('date', state.date);
    if (state.time) sp.set('time', state.time);
    if (state.site) sp.set('site', state.site);
    if (state.feature) sp.set('feature', state.feature);
    return sp;
};
